import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../../config/api";
import { BASE_API } from "../../../../../constants/apiUrls";
import { toast } from "../../../../../lib/toast";
import {
  ErrorMessage,
  GetCommonData,
  Params,
  PostRequest,
} from "../../../../../types";
import { weWorkData } from "../../../../../types/webCms/aboutUs/weWork";

// get all
export const getAllWeeWorkAsync = createAsyncThunk<
  GetCommonData<weWorkData>,
  Params<any>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllWeeWork", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(BASE_API.getHomeHowWeWork);

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    toast("error", error?.message || "Get fail");
    return rejectWithValue(error);
  }
});

// update
export const updateWeWorkAsync = createAsyncThunk<
  null,
  PostRequest<weWorkData, any>
>(
  "admin/updateWeWork",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateHomeHowWeWork}`, data);

      reRender && reRender(true);
      toast("success", "update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "update fail");
      return rejectWithValue(error);
    }
  }
);
